var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24PaymentGetway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-payment_Getway",
    "data-name": "icon-24-payment Getway",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7277",
    "data-name": "Rectangle 7277",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17363",
    "data-name": "Group 17363",
    transform: "translate(1.164 -0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10989",
    "data-name": "Path 10989",
    d: "M17.1,15.6a4.565,4.565,0,0,1,1.841.488l.629-1.585a6.146,6.146,0,0,0-1.876-.515V12.834h-1.66v1.259a2.675,2.675,0,0,0-.973.454,1.947,1.947,0,0,0-.764,1.638,2.422,2.422,0,0,0,.178.972,2.018,2.018,0,0,0,.551.728,4.87,4.87,0,0,0,1.117.655q.82.37,1.01.489a1.02,1.02,0,0,1,.276.236.453.453,0,0,1,.086.273.488.488,0,0,1-.213.407,1.131,1.131,0,0,1-.672.159,4.553,4.553,0,0,1-1.164-.17,6.133,6.133,0,0,1-1.223-.47V21.3a4.738,4.738,0,0,0,1.071.372,5.391,5.391,0,0,0,.718.085v1.126H17.7V21.635a3.328,3.328,0,0,0,.483-.166,2.344,2.344,0,0,0,1.034-.853,2.227,2.227,0,0,0,.359-1.255,2.055,2.055,0,0,0-.383-1.276,3.47,3.47,0,0,0-1.364-.949,8.77,8.77,0,0,1-1.257-.645.5.5,0,0,1-.23-.4.421.421,0,0,1,.183-.348A.958.958,0,0,1,17.1,15.6Z",
    transform: "translate(-7.799 -5.481)",
    fill: "#02466a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10990",
    "data-name": "Path 10990",
    d: "M21.038,9.58H19.919V2.872H.075V21.878H19.92V15.17H21.6V9.58ZM17.683,19.641H2.311V5.108H17.683V9.58h-.7a2.8,2.8,0,1,0,0,5.59c.024,0,.046-.005.07-.005v.005h.628v4.471Zm2.283-6.148H16.985v-.007a1.113,1.113,0,0,1,0-2.222v-.007h2.981Z",
    transform: "translate(0 0)",
    fill: "#02466a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24PaymentGetway);
export default __webpack_public_path__ + "static/media/icon-24-payment Getway.1ad29598b4d079de2c31547087549d25.svg";
export { ForwardRef as ReactComponent };